/* eslint-disable @typescript-eslint/naming-convention */
export enum CommonString {
  'AABB' = 0,
  'AnimationClip' = 5,
  'AnimationCurve' = 19,
  'AnimationState' = 34,
  'Array' = 49,
  'Base' = 55,
  'BitField' = 60,
  'bitset' = 69,
  'bool' = 76,
  'char' = 81,
  'ColorRGBA' = 86,
  'Component' = 96,
  'data' = 106,
  'deque' = 111,
  'double' = 117,
  'dynamic_array' = 124,
  'FastPropertyName' = 138,
  'first' = 155,
  'float' = 161,
  'Font' = 167,
  'GameObject' = 172,
  'Generic Mono' = 183,
  'GradientNEW' = 196,
  'GUID' = 208,
  'GUIStyle' = 213,
  'int' = 222,
  'list' = 226,
  'long long' = 231,
  'map' = 241,
  'Matrix4x4f' = 245,
  'MdFour' = 256,
  'MonoBehaviour' = 263,
  'MonoScript' = 277,
  'm_ByteSize' = 288,
  'm_Curve' = 299,
  'm_EditorClassIdentifier' = 307,
  'm_EditorHideFlags' = 331,
  'm_Enabled' = 349,
  'm_ExtensionPtr' = 359,
  'm_GameObject' = 374,
  'm_Index' = 387,
  'm_IsArray' = 395,
  'm_IsStatic' = 405,
  'm_MetaFlag' = 416,
  'm_Name' = 427,
  'm_ObjectHideFlags' = 434,
  'm_PrefabInternal' = 452,
  'm_PrefabParentObject' = 469,
  'm_Script' = 490,
  'm_StaticEditorFlags' = 499,
  'm_Type' = 519,
  'm_Version' = 526,
  'Object' = 536,
  'pair' = 543,
  'PPtr<Component>' = 548,
  'PPtr<GameObject>' = 564,
  'PPtr<Material>' = 581,
  'PPtr<MonoBehaviour>' = 596,
  'PPtr<MonoScript>' = 616,
  'PPtr<Object>' = 633,
  'PPtr<Prefab>' = 646,
  'PPtr<Sprite>' = 659,
  'PPtr<TextAsset>' = 672,
  'PPtr<Texture>' = 688,
  'PPtr<Texture2D>' = 702,
  'PPtr<Transform>' = 718,
  'Prefab' = 734,
  'Quaternionf' = 741,
  'Rectf' = 753,
  'RectInt' = 759,
  'RectOffset' = 767,
  'second' = 778,
  'set' = 785,
  'short' = 789,
  'size' = 795,
  'SInt16' = 800,
  'SInt32' = 807,
  'SInt64' = 814,
  'SInt8' = 821,
  'staticvector' = 827,
  'string' = 840,
  'TextAsset' = 847,
  'TextMesh' = 857,
  'Texture' = 866,
  'Texture2D' = 874,
  'Transform' = 884,
  'TypelessData' = 894,
  'UInt16' = 907,
  'UInt32' = 914,
  'UInt64' = 921,
  'UInt8' = 928,
  'unsigned int' = 934,
  'unsigned long long' = 947,
  'unsigned short' = 966,
  'vector' = 981,
  'Vector2f' = 988,
  'Vector3f' = 997,
  'Vector4f' = 1006,
  'm_ScriptingClassIdentifier' = 1015,
  'Gradient' = 1042,
  'Type*' = 1051,
  'int2_storage' = 1057,
  'int3_storage' = 1070,
  'BoundsInt' = 1083,
  'm_CorrespondingSourceObject' = 1093,
  'm_PrefabInstance' = 1121,
  'm_PrefabAsset' = 1138,
  'FileSize' = 1152,
  'Hash128' = 1161
}
